import { render, staticRenderFns } from "./add_stadium_ground_price.vue?vue&type=template&id=b0c4b020&"
import script from "./add_stadium_ground_price.vue?vue&type=script&lang=ts&"
export * from "./add_stadium_ground_price.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports